require.register("documenteditor/controllers/fieldBildnrCtrl", function(exports, require, module){
  $0
  
});

